import { fromEventPattern, merge, map, startWith, distinctUntilChanged, switchMap, Observable } from 'rxjs';
import type { EventsKey } from 'ol/events';
import { unByKey } from 'ol/Observable';
  import type BaseLayer from 'ol/layer/Base';

 export const olEvent$ = <T = any>(target: any, type: string) =>
  fromEventPattern<T>(
    handler => target.on(type, handler) as EventsKey | EventsKey[],
    (_handler, key: EventsKey | EventsKey[]) => unByKey(key)
  );



export function layerOpacity$(layer: BaseLayer):Observable<Number> {
  return olEvent$(layer, 'change:opacity').pipe(
    map(() => layer.getOpacity()),
    startWith(layer.getOpacity()),
    distinctUntilChanged()
  );
}

export function layerVisibility$(layer: BaseLayer):Observable<boolean> {
  return olEvent$(layer, 'change:visible').pipe(
    map(() => layer.getVisible()),
    startWith(layer.getVisible()),
    distinctUntilChanged()
  );
}
